import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/chigua";

interface HeaderProps {
  keyword: string;
  setKeyword: (v: string) => void;
}

export default function Header({ keyword, setKeyword }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goLive = () => {
    const el = document.getElementById("live");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center gap-4 px-4 md:px-6 py-3">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
            <i className="ri-water-flash-fill" aria-hidden="true"></i>
          </span>
          <span className="font-fun text-2xl leading-none text-primary-600">看吃瓜</span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex ml-6">
          {navLinks.map((l) => (
            <li key={l.id}>
              <a
                href={`#${l.id}`}
                className="rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700 transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <label className="relative block">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && goLive()}
              placeholder="搜你想吃的瓜"
              className="w-52 rounded-full border border-background-200 bg-background-100/60 py-2 pl-9 pr-4 text-sm outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50"
            />
          </label>
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅新瓜提醒
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航"
          onClick={() => setMobileOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-50 md:hidden"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="mb-3 flex gap-2">
            <label className="relative block flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setMobileOpen(false);
                    goLive();
                  }
                }}
                placeholder="搜你想吃的瓜"
                className="w-full rounded-full border border-background-200 bg-background-100/60 py-2 pl-9 pr-4 text-sm outline-none focus:border-primary-400"
              />
            </label>
          </div>
          <ul className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100/60"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#subscribe"
            onClick={() => setMobileOpen(false)}
            className="mt-3 block whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
          >
            订阅新瓜提醒
          </a>
        </div>
      )}
    </header>
  );
}